import { LoginOutlined, DashboardOutlined } from "@ant-design/icons";
import { Card, Typography, Button, theme } from "antd";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import ThemeToggle from "../../components/ThemeToggle";
import { LOGIN } from "../../constants/routes";
import { useTheme } from "../../contexts/ThemeContext";

const { Title, Text } = Typography;
const { useToken } = theme;

/* =======================
   Layout
======================= */

const PageWrapper = styled.div`
  box-sizing: border-box;
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  position: relative;
`;

const CenterCard = styled(Card)`
  width: 100%;
  max-width: 420px;
  border-radius: 16px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.1);

  .ant-card-body {
    padding: 40px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const IconCircle = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(24, 144, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

const FloatingToggle = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;

/* =======================
   Component
======================= */

const Home = () => {
  const navigate = useNavigate();
  const { token } = useToken();
  const { isDarkMode } = useTheme();

  return (
    <PageWrapper
      style={{
        background: isDarkMode
          ? "radial-gradient(circle at 50% 50%, #1a1a1a 0%, #000000 100%)"
          : "radial-gradient(circle at top left, #e6f7ff 0%, #ffffff 100%)"
      }}
    >
      <FloatingToggle>
        <ThemeToggle />
      </FloatingToggle>

      <CenterCard
        bordered={false}
        style={{
          background: token.colorBgContainer + "E6" // subtle transparency
        }}
      >
        <IconCircle>
          <DashboardOutlined style={{ fontSize: 36, color: token.colorPrimary }} />
        </IconCircle>

        <Title level={3} style={{ marginBottom: 4, fontWeight: 700 }}>
          <span style={{ color: token.colorPrimary }}>TLE</span> Admin
        </Title>

        <Text type="secondary" style={{ marginBottom: 16 }}>
          Platform Management System
        </Text>

        <Text
          style={{
            fontSize: 14,
            color: token.colorTextSecondary,
            marginBottom: 28,
            maxWidth: 280
          }}
        >
          Secure access to analytics, user management, and content administration.
        </Text>

        <Button
          type="primary"
          size="large"
          shape="round"
          icon={<LoginOutlined />}
          style={{ width: "100%", height: 48 }}
          onClick={() => navigate(LOGIN)}
        >
          Log In
        </Button>
      </CenterCard>
    </PageWrapper>
  );
};

export default Home;
